export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40c0077d24c41913fc2397d8c70191cb400f41015d&name=revalidateCommunity!'